import React, { useState, useEffect, useCallback } from "react";
import DocumentsToRequireDetailsView from "./documents-to-require-details.view";
import DocumentsToRequireAddDocumentView from "./documents-to-require-add-new-document.view";
// import "./documents-to-require-configurations.view.css";
import moment from "moment";
import "moment/locale/es";
import { ClientDocument } from "../../../../services";
// import { DialogDeleteDocumentPure } from "../../../pures";
import DocumentsToRequireView from "../documents-to-require.view";
import { useTranslation } from "react-i18next";

const DocumentsToRequireConfigurationView = ({
  selectedUser,
  selectedValueFilter,
  hideShowDetails,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  nameComponentUser,
  token,
  setHeaderTitleinDetail,
  validators,
  forceRefresh,
  toggleDialogYesNo,
  showDialogYesNo,
  clientId,
  typeDocuments,
  preferenceValue,
  handleFile,
  handleDeleteFile,
  selectedFile,
  selectedFileName,
  errorFile,
  selectedFileBase64,
  colorBorderContainer,
  newOptions
}) => {
  const [stateNameComponentUser, setStateNameComponentUser] = useState("");
  const [showLoadingRequesting, setShowLoadingRequesting] = useState(false);
  const [showErrorRequesting, setShowErrorRequesting] = useState(false);
  const [showWarningRequesting, setShowWarningRequesting] = useState(false);
  const [showDetailComponent, setShowComponentDetail] = useState(false);
  const [showCompletedRequesting, setShowCompletedRequesting] = useState(false);
  const { t } = useTranslation()

  const toggleErrorRequesting = () => {
    setShowErrorRequesting(true);
    setTimeout(() => {
      setShowErrorRequesting(false);
      hideShowDetails(true);
    }, 4000);
  };

  const createClientDocument = async (clientDocumentInformation, token) => {
    setShowLoadingRequesting(true);

    try {
      let clientDocument = new ClientDocument(
        process.env.REACT_APP_MIFIRMA_API
      );

      let data = new FormData();
      data.append("clientId", clientDocumentInformation.clientId);
      data.append("documentPersonTypeId", clientDocumentInformation.documentPersonTypeId);
      data.append("nombre", clientDocumentInformation.nombre);
      data.append("description", clientDocumentInformation.description);
      data.append("defaultDocument", false);
      data.append("clientDocumentTypeRequestId", clientDocumentInformation.clientDocumentTypeRequestId);
      data.append("sendOCR", clientDocumentInformation.sendOCR);
      data.append("typeDocumentName", clientDocumentInformation.typeDocumentName);
      data.append("documentForm", clientDocumentInformation.documentForm);

      let res = await clientDocument.createClientDocument(
        data,
        token
      );

      if (res && res.data.statusCode === 200) {
        let documents = await clientDocument.getClientDocumentA3Cloud(
          Number(clientId),
          token
        );

        moment.locale("es");
        documents.data.data.map((documento) => {
          documento.newUpdatedDate = `${t("documentsToRequire.grid.modifiedOn")} ${documento.updatedDate}`;
          documento.activeBtnOne =
            documento.defaultDocument === true ? false : true;
          documento.labelBtnTwo =
            documento.defaultDocument === true
              ? "Ver detalle"
              : "Ver detalle / Editar";
          return documents.data.data;
        });

        let documentsContractorPhysical = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_KEY;
        });

        let documentsContractorMoral = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_KEY;
        });

        let documentsRepsePhysical = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_KEY;
        });

        let documentsRepseMoral = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPSE_MORAL_KEY;
        });

        let documentsContractREPSE = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACT_REPSE_KEY;
        });

        let documentsReportREPSE = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPORT_REPSE_KEY;
        });

        let documentsProcedureUser = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_PROCEDURE_USER_KEY;
        });

        let documentsSigners = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_SIGNERS_KEY;
        });


        let documentsAssemblies = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_ASSEMBLIES_KEY;
        });

        setShowLoadingRequesting(false);
        setShowCompletedRequesting(true);
        await toggleCompletedRequesting(
          true,
          "",
          documentsContractorPhysical,
          documentsContractorMoral,
          documentsRepsePhysical,
          documentsRepseMoral,
          documentsContractREPSE,
          documentsReportREPSE,
          documentsProcedureUser,
          documentsSigners,
          documentsAssemblies
        );
        setTimeout(() => {
          setShowCompletedRequesting(false);
          hideShowDetails();
        }, 4000);
      } else {
        toggleLoadingRequesting(false);
        // toggleErrorRequesting(true);
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      // toggleErrorRequesting(true);
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
      return false;
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const updateClientDocument = async (clientDocumentInformation, token) => {
    setShowLoadingRequesting(true);
    try {
      let clientDocument = new ClientDocument(
        process.env.REACT_APP_MIFIRMA_API
      );

      let data = new FormData();
      data.append("id", clientDocumentInformation.id);
      data.append("nombre", clientDocumentInformation.nombre);
      data.append("description", clientDocumentInformation.description);
      data.append("clientDocumentTypeRequestId", clientDocumentInformation.clientDocumentTypeRequestId);
      data.append("sendOCR", clientDocumentInformation.sendOCR);
      data.append("typeDocumentName", clientDocumentInformation.typeDocumentName);
      data.append("documentForm", clientDocumentInformation.documentForm);

      let res = await clientDocument.updateClientDocument(
        data,
        token
      );
      if (res && res.status === 200) {
        let documents = await clientDocument.getClientDocumentA3Cloud(
          selectedUser.clientId,
          token
        );

        moment.locale("es");
        documents.data.data.map((documento) => {
          documento.newUpdatedDate = `${t("documentsToRequire.grid.modifiedOn")} ${documento.updatedDate}`;
          documento.activeBtnOne =
            documento.defaultDocument === true ? false : true;
          documento.labelBtnTwo =
            documento.defaultDocument === true
              ? t("documentsToRequire.grid.detail")
              : t("documentsToRequire.grid.detailAndEdit");
          if (documento.clientDocumentTypeRequest === null) {
            documento.clientDocumentTypeRequestId = 0
            documento.clientDocumentTypeRequest = { name: 'Sin definir' }
          }
          return documents.data.data;

        });

        let documentsContractorPhysical = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_KEY;
        });

        let documentsContractorMoral = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_KEY;
        });

        let documentsRepsePhysical = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_KEY;
        });

        let documentsRepseMoral = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPSE_MORAL_KEY;
        });

        let documentsContractREPSE = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACT_REPSE_KEY;
        });

        let documentsReportREPSE = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPORT_REPSE_KEY;
        });

        let documentsProcedureUser = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_PROCEDURE_USER_KEY;
        });

        let documentsSigners = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_SIGNERS_KEY;
        });

        let documentsAssemblies = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_ASSEMBLIES_KEY;
        });
        setShowLoadingRequesting(false);
        setShowCompletedRequesting(true);
        await toggleCompletedRequesting(
          true,
          "",
          documentsContractorPhysical,
          documentsContractorMoral,
          documentsRepsePhysical,
          documentsRepseMoral,
          documentsContractREPSE,
          documentsReportREPSE,
          documentsProcedureUser,
          documentsSigners,
          documentsAssemblies
        );
        setTimeout(() => {
          setShowCompletedRequesting(false);
          hideShowDetails();
        }, 4000);
      } else {
        toggleLoadingRequesting(false);
        // toggleErrorRequesting(true);
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      // toggleErrorRequesting(true);
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
      return false;
    }
  };

  const deleteClientDocument = async (clientDocumentInformation, token) => {
    setShowLoadingRequesting(true);
    try {
      let clientDocument = new ClientDocument(
        process.env.REACT_APP_MIFIRMA_API
      );
      let res = await clientDocument.deleteClientDocument(
        clientDocumentInformation,
        token
      );
      if (res && res.data.statusCode === 200) {
        let documents = await clientDocument.getClientDocumentA3Cloud(
          selectedUser.clientId,
          token
        );

        moment.locale("es");
        documents.data.data.map((documento) => {
          documento.newUpdatedDate = `${t("documentsToRequire.grid.modifiedOn")} ${documento.updatedDate}`;
          documento.activeBtnOne =
            documento.defaultDocument === true ? false : true;
          documento.labelBtnTwo =
            documento.defaultDocument === true
              ? t("documentsToRequire.grid.detail")
              : t("documentsToRequire.grid.detailAndEdit")
          return documents.data.data;
        });

        let documentsContractorPhysical = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_KEY;
        });

        let documentsContractorMoral = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_KEY;
        });

        let documentsRepsePhysical = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_KEY;
        });

        let documentsRepseMoral = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPSE_MORAL_KEY;
        });

        let documentsContractREPSE = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_CONTRACT_REPSE_KEY;
        });

        let documentsReportREPSE = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_REPORT_REPSE_KEY;
        });

        let documentsProcedureUser = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_PROCEDURE_USER_KEY;
        });

        let documentsSigners = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_SIGNERS_KEY;
        });


        let documentsAssemblies = documents.data.data.filter((document) => {
          return document.keyDocument === process.env.REACT_APP_PERSON_TYPE_ASSEMBLIES_KEY;
        });

        setShowLoadingRequesting(false);
        setShowCompletedRequesting(true);
        await toggleCompletedRequesting(
          true,
          "",
          documentsContractorPhysical,
          documentsContractorMoral,
          documentsRepsePhysical,
          documentsRepseMoral,
          documentsContractREPSE,
          documentsReportREPSE,
          documentsProcedureUser,
          documentsSigners,
          documentsAssemblies
        );
        setTimeout(() => {
          setShowCompletedRequesting(false);
          hideShowDetails();
        }, 4000);
      } else {
        toggleLoadingRequesting(false);
        // toggleErrorRequesting(true);
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      // toggleErrorRequesting(true);
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
      return false;
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setStateNameComponentUser(nameComponentUser);
  }, [nameComponentUser]);

  useEffect(() => {
    renderComponentUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateNameComponentUser]);

  const renderComponentUser = useCallback(() => {
    switch (stateNameComponentUser) {
      case t("documentsToRequire.grid.detailAndEdit"):
      case t("documentsToRequire.grid.detail"):
        return (
          <DocumentsToRequireDetailsView
            selectedUser={selectedUser}
            selectedValueFilter={selectedValueFilter}
            updateClientDocument={updateClientDocument}
            hideShowDetails={hideShowDetails}
            deleteClientDocument={deleteClientDocument}
            token={token}
            validators={validators}
            showLoadingRequesting={showLoadingRequesting}
            setShowLoadingRequesting={setShowLoadingRequesting}
            setShowCompletedRequesting={setShowCompletedRequesting}
            setShowErrorRequesting={setShowErrorRequesting}
            setHeaderTitleinDetail={setHeaderTitleinDetail}
            setStateNameComponentUser={setStateNameComponentUser}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            setShowComponentDetail={setShowComponentDetail}
            showCompletedRequesting={showCompletedRequesting}
            toggleDialogYesNo={toggleDialogYesNo}
            showDialogYesNo={showDialogYesNo}
            typeDocuments={typeDocuments}
            preferenceValue={preferenceValue}
            handleFile={handleFile}
            handleDeleteFile={handleDeleteFile}
            selectedFile={selectedFile}
            selectedFileName={selectedFileName}
            errorFile={errorFile}
            selectedFileBase64={selectedFileBase64}
            colorBorderContainer={colorBorderContainer}
            newOptions={newOptions}
          />
        );
      case t("documentsToRequire.newDocument"):
        return (
          <DocumentsToRequireAddDocumentView
            selectedUser={selectedUser}
            selectedValueFilter={selectedValueFilter}
            hideShowDetails={hideShowDetails}
            validators={validators}
            token={token}
            setHeaderTitleinDetail={setHeaderTitleinDetail}
            setStateNameComponentUser={setStateNameComponentUser}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompleteRequesting={toggleCompletedRequesting}
            createClientDocument={createClientDocument}
            setShowLoadingRequesting={setShowLoadingRequesting}
            setShowCompletedRequesting={setShowCompletedRequesting}
            setShowErrorRequesting={setShowErrorRequesting}
            showLoadingRequesting={showLoadingRequesting}
            showErrorRequesting={showErrorRequesting}
            showCompletedRequesting={showCompletedRequesting}
            clientId={clientId}
            typeDocuments={typeDocuments}
            preferenceValue={preferenceValue}
            handleFile={handleFile}
            handleDeleteFile={handleDeleteFile}
            selectedFile={selectedFile}
            selectedFileName={selectedFileName}
            errorFile={errorFile}
            selectedFileBase64={selectedFileBase64}
            colorBorderContainer={colorBorderContainer}
            newOptions={newOptions}
          />
        );
      default:
        return;
    }
  }, [
    stateNameComponentUser,
    selectedUser,
    hideShowDetails,
    deleteClientDocument,
    toggleCompletedRequesting,
    toggleErrorRequesting,
    toggleLoadingRequesting,
    toggleDialogYesNo,
    setHeaderTitleinDetail,
    token,
    showLoadingRequesting,
    showDetailComponent,
    showDialogYesNo,
    validators,
    updateClientDocument,
    showCompletedRequesting,
  ]);

  return <>{renderComponentUser()}</>;
};

export default DocumentsToRequireConfigurationView;

